import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, makeStyles } from '@material-ui/core';
import SearchSelectorPill from '../../components/core/Pill/SearchSelectorPill';
import FilterButton from '../../components/buttons/FilterButton';
import SearchKeywordPill from '../../components/core/Pill/SearchKeywordPill';
import { getFiltersCount } from '../../utils/searchFilters';
import { FILTER_TYPES } from '../../utils/constants/FilterTypes';
import DateTime from '../../utils/dateTimeHelpers';
import { REFINED_SEARCH_MONTH_DATE_NO_ZERO_PADDING } from '../../assets/dateFormats';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '1115px',
    display: 'inline-flex',
    width: '100%',
    height: 'fit-content',
    overflowX: 'auto',
    margin: theme.spacing(3, 'auto'),
    minHeight: '32px',
  },
  filterControls: {
    display: 'inline-flex',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    margin: '0 auto',
    padding: theme.spacing(0, 1),
    minHeight: '32px',
  },
  filterButtonContainer: {
    margin: theme.spacing(0, 0.5),
  },
}));

const SearchFilters = ({
  isRefineSearchActive,
  openFilterModalContainerHandler,
  openRefineSearchHandler,
  resetSearchQuery,
}) => {
  const classes = useStyles();
  const { currentFilters } = useSelector((state) => state.filters);
  const { currentQuery } = useSelector((state) => state.search);
  const { refinedDate, refinedTime, refinedGuests } = useSelector(
    (state) => state.availability
  );

  const formatDateForSearchPill = (date) => {
    const isoStringDate = date && new Date(date).toISOString(); // the refinedDate variable gets this format: Wed Apr 23 2025 00:00:00 GMT-0700 (Pacific Daylight Time)
    return new DateTime(isoStringDate).toFormat(
      REFINED_SEARCH_MONTH_DATE_NO_ZERO_PADDING
    );
  };

  const activeFiltersCount = useMemo(
    () =>
      getFiltersCount(currentFilters, [
        FILTER_TYPES.VENUE_TYPE,
        FILTER_TYPES.CATEGORIES,
      ]),
    [currentFilters]
  );

  return (
    <Box className={classes.root}>
      <Box className={classes.filterControls}>
        <Box>
          <SearchSelectorPill
            isActive={isRefineSearchActive}
            onClick={openRefineSearchHandler}
            date={formatDateForSearchPill(refinedDate)}
            time={refinedTime}
            guestNumber={refinedGuests}
          />
        </Box>
        <Box className={classes.filterButtonContainer}>
          <FilterButton
            isActive={activeFiltersCount}
            onClick={openFilterModalContainerHandler}
          />
        </Box>
        <Box>
          {currentQuery && (
            <SearchKeywordPill
              onClose={resetSearchQuery}
              searchText={currentQuery}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};
export default SearchFilters;
